<template>
    <CardUploadFiles
        :isVisiblePrimary="false"
        :titleCard="'Precisamos verificar seu comprovante de residência'"
        :cardDescription="'proof_of_address'"
        :textCard="'Comprovante de residência'"
        :textCardAttention="'O comprovante de residência precisa ser dos últimos 3 meses'"
        :isVisibleSecondaryCard="true"
        :textSencondaryCardAttention="'O comprovante deve estar no nome do titular ou de seus pais'"
        :srcExampleImage="IconDocument"
        :nextRoute="'SavedPersonalDataFiles'"
        :previewScreen="'PreviewPersonalDataFiles'"
    />
</template>
<script>
    import CardUploadFiles from '../../components/CardUploadFiles.vue'
    import HeaderTitle from '@/cadastro/components/HeaderTitle.vue';
    import IconDocument from '../../../../public/images/proof.svg'

    export default {
        components: {
            CardUploadFiles,
            HeaderTitle
        },
        setup() {
            return {
                IconDocument
            };
        },
    }
</script>